import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=d2864c54&scoped=true&"
import script from "./freight.vue?vue&type=script&lang=js&"
export * from "./freight.vue?vue&type=script&lang=js&"
import style0 from "./freight.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./freight.vue?vue&type=style&index=1&id=d2864c54&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2864c54",
  null
  
)

export default component.exports